import { Card } from "@/components/ui/card";
import { Check } from "lucide-react";

interface Choice {
  id: string;
  label: string;
}

interface MultiSelectStepProps {
  title: string;
  description?: string;
  choices: Choice[];
  selected: string[];
  onChange: (values: string[]) => void;
}

export const MultiSelectStep = ({
  title,
  description,
  choices,
  selected,
  onChange,
}: MultiSelectStepProps) => {
  const toggleChoice = (id: string) => {
    const newSelected = selected.includes(id)
      ? selected.filter((s) => s !== id)
      : [...selected, id];
    onChange(newSelected);
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold font-nexa">{title}</h2>
      {description && <p className="text-muted-foreground">{description}</p>}
      <div className="grid gap-4">
        {choices.map((choice) => (
          <Card
            key={choice.id}
            className={`p-4 cursor-pointer transition-all ${
              selected.includes(choice.id)
                ? "border-secondary bg-primary text-primary-foreground"
                : "hover:border-secondary"
            }`}
            onClick={() => toggleChoice(choice.id)}
          >
            <div className="flex items-center justify-between">
              <span
                className={
                  selected.includes(choice.id) ? "text-primary-foreground" : "text-foreground"
                }
              >
                {choice.label}
              </span>
              {selected.includes(choice.id) && (
                <Check className="h-5 w-5 text-secondary" />
              )}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};